<template>
  <v-flex xs12 sm6 d-flex>
    <v-select
      :items="kinds"
      label="Tipo Transação"
      v-model="kind"
      item-text="title"
      item-value="kinds"
      return-object
      prepend-icon="price_check"
    ></v-select>
  </v-flex>
</template>
<script>
import { mapGetters } from "vuex";
import * as kinds from "@/helpers/walletTransactionsKind";

export default {
  name: "kind",
  computed: {
    kind: {
      get() {
        return this.model;
      },
      set(selected) {
        this.$store.dispatch("wallet/kind", selected.kinds);
        this.model;
      },
    },
    ...mapGetters({
      model: "wallet/kind",
    }),
  },
  data: () => ({
    kinds: [
      {
        title: "Todos",
        kinds: "",
      },
      {
        title: "Acréscimo do Sistema",
        kinds: kinds.DIGITAL_SYSTEM_INCREMMENT,
      },
      {
        title: "Decréscimo do Sistema",
        kinds: kinds.DIGITAL_SYSTEM_DECREMMENT,
      },
      { title: "Depósito", kinds: kinds.DIGITAL_DEPOSIT },
      { title: "Estorno", kinds: kinds.REFOUND },
      { title: "Liquidação", kinds: kinds.DIGITAL_LIQUIDATION },
      { title: "Pagamento de Contas", kinds: kinds.DIGITAL_PAYMENT },
      { title: "Recarga", kinds: kinds.DIGITAL_RECHARGE },
      { title: "Saque", kinds: kinds.DIGITAL_WITHDRAW },
      {
        title: "Transferência Digital Enviada",
        kinds: kinds.DIGITAL_TRANSFER_SENDED,
      },
      {
        title: "Transferência Digital Recebida",
        kinds: kinds.DIGITAL_TRANSFER_RECEIVED,
      },
      {
        title: "Transferência Swipe Acréscimo",
        kinds: kinds.DIGITAL_SWIPE_TRANSFER_INCREMMENT,
      },
      {
        title: "Transferência Swipe Decréscimo",
        kinds: kinds.DIGITAL_SWIPE_TRANSFER_DECREMMENT,
      },
    ],
  }),
  methods: {
    
  },
};
</script>
